import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { legalApi } from '@/api/endpoints'

declare global {
  interface Window {
    __loadYandexMetrika?: () => void
  }
}

const COOKIE_NAME = 'nurm_cookie_preferences'
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365
const ANALYTICS_VALUE = 'analytics'
const NECESSARY_VALUE = 'necessary'

const getCookiePreference = () => {
  const prefix = `${COOKIE_NAME}=`
  const value = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(prefix))
    ?.slice(prefix.length)

  return value ? decodeURIComponent(value) : null
}

const saveCookiePreference = (value: string) => {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax`
}

const loadAnalytics = () => {
  window.__loadYandexMetrika?.()
}

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const preference = getCookiePreference()
    if (preference === ANALYTICS_VALUE) {
      loadAnalytics()
    }
    setVisible(!preference)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-1100 border-t border-gray-200 bg-white/95 px-4 py-4 shadow-[0_-18px_50px_-30px_rgba(15,23,42,0.45)] backdrop-blur">
      <div className="container mx-auto flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-6 text-gray-700">
          NurM использует обязательные cookie и хранилища браузера для работы сайта,
          корзины, авторизации и настроек. Яндекс.Метрика включается только при
          выборе аналитических cookie. Подробнее — в{' '}
          <Link to="/legal/cookies" className="text-primary hover:underline">
            Политике cookie
          </Link>
          .
        </p>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={() => {
              saveCookiePreference(NECESSARY_VALUE)
              void legalApi.acceptConsent({
                document_slug: 'cookies',
                action: 'necessary_cookies',
              })
              setVisible(false)
            }}
            className="h-10 rounded-md border border-gray-200 px-5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Только необходимые
          </button>
          <button
            type="button"
            onClick={() => {
              saveCookiePreference(ANALYTICS_VALUE)
              void legalApi
                .acceptConsent({
                  document_slug: 'cookies',
                  action: 'analytics_cookies',
                })
                .finally(loadAnalytics)
              setVisible(false)
            }}
            className="h-10 rounded-md bg-primary px-5 text-sm font-semibold text-white hover:bg-primary-hover"
          >
            Принять аналитические
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsentBanner
